import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import AgGridTable from "../../utilities/AgGridTable";
import Cards from "./Card";
// import data from "./data";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import {
  AppBar,
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import PartOrderComment from "./PartOrderComment";
import Notification from "./Notification";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import OrderDetail from "../view-order/OrderDetail";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";
import jwtDecode from "jwt-decode";
import ViewPDF from "./ViewPDF";
import ViewPDFEdit from "./ViewPDFEdit";
import SendNotification from "./SendNotification";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify"
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .inprogress":
    {
      borderRadius: "20px",
      fontSize: "11px",
      textAlign: "center",
      height: "26px",
      lineHeight: "26px",
      padding: "0px 10px",
      marginTop: "6px",
      color: theme.palette.common.white,
    },
    "& .new": {
      backgroundColor: theme.palette.info.main,
    },
    "& .assigned": {
      backgroundColor: theme.palette.warning.main,
    },
    "& .placed": {
      backgroundColor: theme.palette.grey[500],
    },
    "& .ab_received": {
      backgroundColor: theme.palette.success.main,
    },
    "& .invoiced": {
      backgroundColor: theme.palette.success.main,
    },
    "& .inprogress": {
      backgroundColor: theme.palette.success.main,
    },
  },
}));

const handleDateFormat = (props) => {
  return props.value && moment(props.value).format("DD-MM-YYYY - HH:mm");
};

const steps = [
  { status: "New", date: "12-10-2023" },
  { status: "Assigned", date: "12-10-2023" },
  { status: "In Progress" },
  { status: "Order Placed" },
  { status: "ACK From Factory" },
  { status: "AB Received" },
  { status: "Under Confirmation" },
  { status: "Confirmed" },
  { status: "Ready to Book" },
  { status: "Production Planning" },
  { status: "PI Generated" },
  { status: "Ready to Release" },
  { status: "Released" },
  { status: "Loaded" },
  { status: "Invoiced" },
];

const NewABsList = (props) => {
  const theme = useTheme();

const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles(props);
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
  const [error, setError] = useState();
  const gridRef = useRef();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [open, setOpen] = useState(false);
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.dashboardOrderCriteria}`;
  const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
  const stateRef = useRef();
  const saveGridStateName = 'newABsList';

  const [gridApi, setGridApi] = useState(null);
  const baseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const [sendBtnEnable, setSendBtnEnable] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const ABAction = (props) => {
    const [open, setOpen] = useState(false);
    const [rowValue, setRowValue] = useState(() => {
      const initialData = props?.data?.data;
      if (initialData && initialData.abFiles) {
        const sortedAbFiles = [...initialData.abFiles].sort((a, b) => {
          return new Date(b.createdDate) - new Date(a.createdDate);
        });

        return { ...initialData, abFiles: sortedAbFiles };
      }
      return initialData;
    });
    const [openPDF, setOpenPDF] = useState(false);
    const [openNotification, setOpenNotification] = useState(false);
    const [openNotificationSend, setOpenNotificationSend] = useState(false);
    const amendmentUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderABFiles}`;
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
    const token =
      localStorage &&
      localStorage.getItem("token") &&
      jwtDecode(localStorage.getItem("token"));
    const hasPartnersRole = [
      "ROLE_PARTNER",
      "ROLE_PARTNER_ADMIN",
      "ROLE_SHWRMMGR",
      "ROLE_PARTNRDESIGN",
      "ROLE_PARTNRORDPROCESS",
    ].some((role) => token?.scope?.includes(role));
    const handleClose = () => {
      setOpen(false);
    };

    const handlePDFClose = () => {
      setOpenPDF(false);
    };

    const handleNotificationClose = () => {
      setOpenNotification(false);
    };
    const handleNotificationCloseSend = () => {
      setOpenNotificationSend(false);
    };

    const handleComment = () => {
      setOpen(true);
    };

    const handleViewPDF = () => {
      setOpenPDF(true);
    };

    const handleSubmit = async (value) => {
      setSuccessMsg("");
      setOpen(false);

      try {
        const file = await OAuthService.getPostPdf(
          url + `api/downloadAbFile/${rowValue?.abFiles[0]?.id}`
        );
        const blob = new Blob([file?.data], { type: "application/pdf" });

        const formData = new FormData();
        formData.append("abPdf", blob, `${rowValue?.abFiles[0]?.abNumber}.pdf`);
        if (value?.trim()) {
          formData.append("comment", value);
        }

        const response = await OAuthService.addFiles(
          url +
          `api/sendAbNotification?abFileId=${rowValue?.abFiles[0]?.id}&orderId=${rowValue?.id}`,
          formData
        );
        setSuccessMsg("AB file send to customer successfully");
        setSnackState(true);
        getNewABsData();
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    };

    const handleSend = () => {
      setOpenNotification(true);
    };
    const handleSendNotification = () => {
      setOpenNotificationSend(true);
    };
    const handleDownload = async () => {
      const file = await OAuthService.getPostPdf(
        url + `api/downloadAbFile/${rowValue?.abFiles[0]?.id}`
      );

      const blob = new Blob([file?.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${rowValue?.abFiles[0]?.abNumber}`;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    };

    const handleSuccess = (msg) => {
      setSuccessMsg(msg);
      msg ? setSnackState(true) : setSnackState(false);
      msg && getNewABsData();
    };

    const handleError = (msg) => {
      setError(msg);
    };
    return (
      <>
        <div className="flex items-center justify-center gap-1 flex-nowrap">
          <Tooltip title={"PDF"}>
            <IconButton onClick={handleViewPDF}>
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:document-text
              </FuseSvgIcon>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Comment"}>
            <IconButton onClick={handleComment}>
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:annotation
              </FuseSvgIcon>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Send"}>
            <IconButton onClick={handleSendNotification}>
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:arrow-circle-right
              </FuseSvgIcon>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Download AB"}>
            <IconButton onClick={handleDownload}>
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:arrow-down-tray
              </FuseSvgIcon>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Upload AB"}>
            <IconButton onClick={handleSend}>
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:arrow-up-tray
              </FuseSvgIcon>
            </IconButton>
          </Tooltip>
        </div>
        <PartOrderComment
          open={open}
          abFiles={rowValue?.abFiles}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
          title={"Comment"}
        />
        <ViewPDFEdit
          open={openPDF}
          abFiles={rowValue?.abFiles}
          handleClose={handlePDFClose}
          title={"View AB"}
          orderStatus={rowValue?.orderStatus}
          partnerStatus={hasPartnersRole}
          orderId={rowValue?.id}
          handleSuccess={handleSuccess}
          handleError={handleError}
        />
        <Notification
          open={openNotification}
          abFiles={rowValue?.abFiles}
          onClose={handleNotificationClose}
          handleSuccess={handleSuccess}
          handleError={handleError}
          orderId={rowValue?.id}
        />
        <SendNotification
          open={openNotificationSend}
          abFiles={rowValue?.abFiles}
          onClose={handleNotificationCloseSend}
          handleSuccess={handleSuccess}
          handleError={handleError}
          orderId={rowValue?.id}
        />
      </>
    );
  };
  var filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      var dateAsString = cellValue;
      //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
      const date = new Date(dateAsString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      if (formattedDate == null) return -1;
      var dateParts = formattedDate.split("/");
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    maxValidYear: new Date().getFullYear(),
  };
  const gridStyle = useMemo(
    () => ({ height: "calc(100% - 22.2px)", width: "100%" }),
    []
  );
  useEffect(() => {
    if (!selectedRows || selectedRows.length === 0) {
      setSendBtnEnable(false);
      return;
    }

    const allSameOrderRef = selectedRows.every(
      (row) => row.projectNum.slice(0, 6) === selectedRows[0].projectNum.slice(0, 6)
    );

    const validCategory = selectedRows.every(
      (row) => row.orderCategory === "PRJ" || row.orderCategory === "CPRJ"
    );

    const hasFiles = selectedRows.every(
      (row) => row.abFiles && row.abFiles.length > 0
    );

    setSendBtnEnable(allSameOrderRef && validCategory && hasFiles);
  }, [selectedRows]);
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);
  const onSelectionChanged = (params) => {
    setSelectedRows(params?.api?.getSelectedRows());

  };

  useEffect(() => {
    if (saveGridStateName) {
      stateRef.current = {
        screenName: saveGridStateName,
        screenState: stateData,
      };
    }
  }, [stateData]);

  const onFirstDataRendered = (params) => {
    const savedState = localStorage.getItem(`gridState-${saveGridStateName}`);
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.screenState?.filter) {
          params.api.setFilterModel(data.screenState.filter);
        }
        if (data.screenState?.columnState) {
          params.columnApi.applyColumnState({
            state: data.screenState.columnState,
            applyOrder: true,
          });
        }
        if (data.screenState?.columnGroupState) {
          params.columnApi.setColumnGroupState(data.screenState.columnGroupState);
        }
      } catch (err) {
        console.error('Failed to load grid state:', err);
      }
    }

  };
  useEffect(() => {
    const unloadCallback = () => {
      if (saveGridStateName && stateRef.current) {
        localStorage.setItem(`gridState-${saveGridStateName}`, JSON.stringify(stateRef.current));
      }
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
      unloadCallback();
    };
  }, []);


  const onFilterChanged = (params) => {
    stateData.filter = params.api.getFilterModel();
    setStateData({ ...stateData });
    if (!gridApi) return;
    gridApi.refreshCells({ columns: ["srNo"] });
  };

  const onColumnStateChanged = (params) => {
    stateData.columnState = params.columnApi.getColumnState();
    stateData.columnGroupState = params.columnApi.getColumnGroupState();
    setStateData({ ...stateData });
  };

  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sr No.",
      minWidth: 70,
      maxWidth: 70,
      field: "srNo",
      pinned: "left",
      filter: false,
      resizable: true,
      editable: false,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      field: "abNumber",
      headerName: "AB Number",
      enableRowGroup: true,
      minWidth: 100,
    },
    {
      field: "commissionName",
      headerName: "Commission Name",
      enableRowGroup: true,
      minWidth: 250,
    },
    {
      field: "orderCategory",
      headerName: "Order Category",
      enableRowGroup: true,
      minWidth: 50,
    },
    {
      field: "customerName",
      headerName: "Customer",
      enableRowGroup: true,
      minWidth: 50,
    },
    {
      field: "country",
      headerName: "Country",
      enableRowGroup: true,
      minWidth: 50,
    },
    {
      field: "volume",
      headerName: "Volume",
      enableRowGroup: true,
      minWidth: 50,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "weight",
      headerName: "Weight",
      enableRowGroup: true,
      minWidth: 50,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "revisedLpWg1",
      enableRowGroup: true,
      minWidth: 50,
      headerName: "LP WG1",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "revisedLpWg2",
      enableRowGroup: true,
      headerName: "LP WG2",
      minWidth: 50,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },

    {
      field: "totalRevisedLpWg1Wg2",
      enableRowGroup: true,
      headerName: "Total LP",
      minWidth: 50,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      enableRowGroup: true,
      headerName: "Loading Week",
      valueGetter: (params) => {
        if (!params.data) return null;
        const abFiles = params.data.abFiles || [];
        const loadingWeek =
          abFiles.length > 0 ? abFiles[abFiles.length - 1]?.loadingWeek : null;
        return loadingWeek === 0 ? "On Hold" : loadingWeek;
      },
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      enableRowGroup: true,
      headerName: "AB Received",
      cellRenderer: handleDateFormat,
      minWidth: 50,
      valueGetter: (params) => {
        if (params.node.group) {
          return null;
        }
        const abFiles = params?.data?.abFiles || [];
        return abFiles.length > 0
          ? abFiles[abFiles.length - 1]?.processedTime
          : null;
      },
      filter: "agDateColumnFilter",
      filterParams,
      sort: "desc",
    },
   {
  cellRenderer: (data) => <ABAction data={data} />,
  headerName: "Actions",
  minWidth: 220,
  maxWidth: 220,
  resizable: false,
  sortable: false,
  filter: false,
  cellStyle: { overflow: "visible" },
},
  ]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      floatingFilter: true,
      resizable: true,
      editable: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: { buttons: ['clear'] },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: { defaultToNothingSelected: true, buttons: ['clear'] },
          },
        ]
      },

    };
  }, []);
  const getNewABsData = async () => {
    gridApi?.showLoadingOverlay();
    try {
      const result = await OAuthService.getPostList(
        `${url}?tilesStatus=newAb&sort=createdDate,desc`,
        {}
      );
      setRowData(result.data);
    } catch (e) {
      console.log("error", e);
      setError(e.message);
      setRowData([]);
    }finally{
       gridApi?.hideOverlay();
    }
  };
  useEffect(() => {
    if(gridApi){

      getNewABsData();
    }
  }, [gridApi]);

  const onRowDoubleClicked = (params) => {
    // setOpen(true);
    var filename = params?.data?.id;
    navigate("/order/order-details/" + filename);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCreateOrder = () => {
    navigate("/create-order/");
  };
  const handleDefaultGridState = () => {
    gridRef.current.api.setFilterModel(null);
    gridRef.current.columnApi.resetColumnState();

  };
  const onBtExport = useCallback(() => {
    const params = {
      fileName: "NewABs.xlsx",
      sheetName: "New ABs",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);
  const handleConfirmAbs = async () => {
    // const abFileIds = selectedRows.map(row => {
    //   const files = row?.abFiles;
    //   return files[files.length - 1]?.id;
    // });
    const abFileIds = selectedRows
      .map(row => {
        const files = row?.abFiles || [];
        return files[files.length - 1]?.id;
      })
      .filter(Boolean);

    const payload = {
      abFileIds
    };
    try {
      const response = await OAuthService.addData(
        `${baseUrl}api/sendFinalProjectABToCustomer`, payload
      );
      toast.success("AB files send to customer successfully");
      getNewABsData();
      setSendBtnEnable(false)
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
      setSendBtnEnable(false)
    }


  };
  const handleBack = () => {
    navigate("/order/dashboard");
  };

  const orderHeaderAction = () => {
    // const navigate = useNavigate();
    return (
      <>
        <Tooltip title={"Back"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleBack}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>
              heroicons-solid:arrow-narrow-left
            </FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"AB Confirmation"}>
          <Button
            variant="contained"
            color="secondary"
            disabled={!sendBtnEnable}
            onClick={handleConfirmAbs}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>
              heroicons-outline:chevron-double-right
            </FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Export New AB's Order"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onBtExport}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Default Grid State"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDefaultGridState}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>material-outline:grid_on</FuseSvgIcon>
          </Button>
        </Tooltip>
      </>
    );
  };
  return (
    <>
      <FormPageHeader
        componentName="New ABs"
        error={error}
        pageName="New ABs"
        currentPage={"New ABs"}
        snackState={snackState}
        successMsg={successMsg}
        orderHeaderAction={orderHeaderAction()}
      >
        {/* <Box className="flex px-16" sx={{ pb: 1 }}>
          <Box sx={{ px: 1 }}>
            <Select
              required
              placeholder={"Customer"}
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <Select
              required
              placeholder={"Country"}
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
            >
              Search
            </Button>
          </Box>
        </Box> */}
      </FormPageHeader>
      <div
        className={clsx(classes.root, "h-full order-grid")}
        style={{ height: "100%", width: "100%" }}
      >
        <div
          style={gridStyle}
          className={`grid ${theme.palette.mode === "dark"
              ? "ag-theme-alpine-dark"
              : "ag-theme-alpine"
            }`}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            defaultColDef={defaultColDef}
            onFilterChanged={onFilterChanged}
            ref={gridRef}
            onRowDoubleClicked={onRowDoubleClicked}
            hideCheckbox={true}
            editable={false}
            rowHeight={22}
            suppressDragLeaveHidesColumns={true}
            onFirstDataRendered={onFirstDataRendered}
            onColumnMoved={onColumnStateChanged}
            onColumnPinned={onColumnStateChanged}
            onColumnVisible={onColumnStateChanged}
            onColumnResized={onColumnStateChanged}
            onColumnRowGroupChanged={onColumnGroupChange}
            rowSelection="multiple"
            cellSelection={true}
            suppressRowClickSelection={true}
            onSelectionChanged={onSelectionChanged}
            rowGroupPanelShow="always"
            groupDisplayType="multipleColumns"
            autoGroupColumnDef={{
              headerName: "Group",
              minWidth: 200,
              cellRendererParams: {
                suppressCount: false,
                checkbox: false,
              },
              pinned: "left",
            }}
          />
        </div>
      </div>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              View Order
            </Typography>
            <IconButton onClick={handleClose} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "" }}>
          <Box sx={{ width: "100%", my: 1 }}>
            <Stepper activeStep={1} alternativeLabel>
              {steps?.map((label) => (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      "& .MuiStepLabel-label": {
                        fontSize: "12px",
                        marginTop: "0px !important",
                      },
                      "& .MuiSvgIcon-root": { width: "0.8em", height: "0.8em" },
                    }}
                  >
                    {label?.status}
                    <br />
                    <small>{label?.date}</small>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
          <OrderDetail />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default NewABsList;
